import { defineMessages } from 'react-intl'

export default defineMessages({
    incompleteTitle: {
        id: 'containers.SupplierPage.RequiredFields.incomplete',
        defaultMessage: 'The following information is required',
    },
    completeTitle: {
        id: 'containers.SupplierPage.RequiredFields.complete',
        defaultMessage: 'All required fields have been inserted.',
    },
    completeSubTitle: {
        id: 'containers.SupplierPage.RequiredFields.completeSubTitle',
        defaultMessage: 'Click "Complete supplier setup" to invite and activate the supplier. You can add more information later.',
    },
    completeSupplier: {
        id: 'containers.SupplierPage.RequiredFields.completeSupplier',
        defaultMessage: 'Complete supplier setup',
    }
})
